import { render } from "./AwardedPersonInformation.vue?vue&type=template&id=693bfb3c"
import script from "./AwardedPersonInformation.vue?vue&type=script&lang=js"
export * from "./AwardedPersonInformation.vue?vue&type=script&lang=js"

import "./AwardedPersonInformation.vue?vue&type=style&index=0&id=693bfb3c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__